import {
  REGISTRATION_CLEAR,
  REGISTRATION_ERROR,
  REGISTRATION_LOAD,
  REGISTRATION_PATCH,
  REGISTRATION_SET_LOADING,
  REGISTRATIONS_STATISTICS_ERROR,
  REGISTRATIONS_STATISTICS_LOAD,
  REGISTRATIONS_STATISTICS_SET_LOADING,
} from '../actions/types';

const initialState = {
  registrationNumbers: [],
  count: 0,
  isLoading: false,
  // statistics
  statisticsLoading: false,
  currentYear: null,
  registrationStats: [],
  reregistrationStats: [],
};

export default function loan(state = initialState, action) {
  const { type, payload } = action;
  const { registrationNumbers } = state;

  switch (type) {
    case REGISTRATION_LOAD:
      return { ...state, ...payload };
    case REGISTRATION_PATCH:
      return {
        ...state,
        registrationNumbers: [
          payload,
          ...registrationNumbers.filter(({ _id }) => _id !== payload._id),
        ],
      };
    case REGISTRATION_SET_LOADING:
      return {
        ...state,
        isLoading: payload,
      };
    case REGISTRATIONS_STATISTICS_SET_LOADING:
      return {
        ...state,
        statisticsLoading: payload,
      };
    case REGISTRATIONS_STATISTICS_LOAD:
      return {
        ...state,
        currentYear: payload.currentYear,
        registrationStats: payload.registrationStats || [],
        reregistrationStats: payload.reregistrationStats || [],
      };
    case REGISTRATIONS_STATISTICS_ERROR:
      return state;
    case REGISTRATION_CLEAR:
      return initialState;
    case REGISTRATION_ERROR:
      return state;
    default:
      return state;
  }
}
